import PropTypes from "prop-types";
import "./LegalNotices.css";
import Header from "../common/Header";
import Footer from "../common/Footer";
import PageWrapper from "../common/PageWrapper";

const LegalNotices = ({ menuState }) => {
  const { isMenuOpen, setIsMenuOpen, onMenuToggle } = menuState;

  return (
    <div className="legal-notices-wrapper">
      <Header
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        onMenuToggle={onMenuToggle}
      />
      <PageWrapper isMenuOpen={isMenuOpen}>
        <main className="legal-notices-content">
          <section className="legal-notices-introduction">
            <h1>Mentions Légales Véhidoc</h1>
            
          </section>

          <section className="legal-notices-section">
            <h2>Informations Générales</h2>
            <ul>
              <li><strong>Dénomination sociale :</strong> MFLJ</li>
              <li><strong>Forme juridique :</strong> SARL</li>
              <li><strong>Montant du capital social :</strong> 15.000 €</li>
              <li><strong>Adresse du siège social :</strong> 12 C rue de la Vigne - 35370 - ETRELLES</li>
              <li><strong>Adresse de courrier électronique :</strong> contact@vehidoc.fr</li>
              <li><strong>N° de téléphone :</strong> 07 81 28 30 33</li>
              <li><strong>N° RCS :</strong> RCS RENNES 824 278 196</li>
              <li><strong>N° de TVA intracommunautaire :</strong> FR 20 824278196</li>
            </ul>
          </section>

          <section className="legal-notices-section">
            <h2>Développement et Hébergement</h2>
            <ul>
              <li><strong>Société :</strong> SIPCO</li>
              <li><strong>Adresse :</strong> 12 rue des artisans - 35500 Vitré</li>
              <li><strong>Téléphone :</strong> 02 99 76 16 16</li>
            </ul>
          </section>
        </main>
      </PageWrapper>
      <Footer />
    </div>
  );
};

LegalNotices.propTypes = {
  menuState: PropTypes.shape({
    isMenuOpen: PropTypes.bool.isRequired,
    setIsMenuOpen: PropTypes.func.isRequired,
    onMenuToggle: PropTypes.func.isRequired,
  }).isRequired,
};

export default LegalNotices;